import VisiblyAdminNavItemGuard from "../components/sidebar/navItemGuards/VisiblyAdminNavItemGuard";
import { SidebarItemsType, SidebarSectionType } from "../types/sidebar";
import { Users, Briefcase } from "react-feather";

const complianceSection = [
  {
    href: "/compliance/direct-workforce",
    icon: Users,
    title: () => "Direct workforce",
    innerNavigationItems: [
      {
        title: "Dashboard",
        to: (_) => "/compliance/direct-workforce/dashboard",
      },
      {
        title: "Project roles",
        to: (_) => "/compliance/direct-workforce/project-roles",
      },
      {
        title: "Workers",
        to: (_) => "/compliance/direct-workforce/workers",
      },
      {
        title: "Worker roles",
        to: (_) => "/compliance/direct-workforce/worker-roles",
      },
      {
        title: "Accreditations",
        to: (_) => "/compliance/direct-workforce/accreditations",
      },
    ],
    children: [
      {
        title: (workerName: string) => `${workerName}`,
        hasBackButton: true,
        backButtonTo: (_) => `/compliance/direct-workforce/workers`,
        type: "worker",
        innerNavigationItems: [
          {
            title: "Details",
            to: (_) =>
              `/compliance/direct-workforce/workers/${_.workerId}/details`,
          },
          {
            title: "Worker roles",
            to: (_) =>
              `/compliance/direct-workforce/workers/${_.workerId}/worker-roles`,
          },
          {
            title: "Accreditations",
            to: (_) =>
              `/compliance/direct-workforce/workers/${_.workerId}/accreditations`,
          },
        ],
      },
    ],
  },
] as SidebarItemsType[];

const internalAdminSection = [
  {
    href: "/internal-admin/create-organisation",
    icon: Briefcase,
    title: () => "Create Organisation",
  },
] as SidebarItemsType[];

const navSections = [
  {
    title: "Compliance",
    pages: complianceSection,
    wrapperElement: (key, children) => {
      return <>{children}</>;
    },
  },
  {
    title: "Internal admin",
    pages: internalAdminSection,
    wrapperElement: (key, children) => {
      return (
        <VisiblyAdminNavItemGuard key={key}>
          {children}
        </VisiblyAdminNavItemGuard>
      );
    },
  },
] as SidebarSectionType[];

export default navSections;
